import React from "react";

function RadioBtns({ target, setTarget, setCustomTarget }) {
  return (
    <div className="control is-flex has-text-dark mb-4" style={{ gap: "10px" }}>
      <div
        className={`targetBtn ${target === 50 ? "targetBtnSelected" : ""}`}
        onClick={() => {
          setTarget(50);
          setCustomTarget("");
        }}
      >
        <p className="has-text-weight-bold">£50</p>
      </div>
      <div
        className={`targetBtn ${target === 100 ? "targetBtnSelected" : ""}`}
        onClick={() => {
          setTarget(100);
          setCustomTarget("");
        }}
      >
        <p className="has-text-weight-bold">£100</p>
        <p className="text-body-xs">most popular</p>
      </div>
      <div
        className={`targetBtn ${target === 250 ? "targetBtnSelected" : ""}`}
        onClick={() => {
          setTarget(250);
          setCustomTarget("");
        }}
      >
        <p className="has-text-weight-bold">£250</p>
      </div>
    </div>
  );
}

export default RadioBtns;
